// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vuex from 'vuex'
import axios from 'axios';
import ajax from './assets/js/request.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/style/public.css';

Vue.use(ElementUI);

Vue.prototype.$ajax = axios;

Vue.use(ajax)

Vue.config.productionTip = false

// 请求拦截
axios.interceptors.request.use(config => {
	return config
}, error => {
	console.log(222, error)
	return Promise.reject(error)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js